<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'AppEntryPoint',
  })
</script>
